var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSelectShape(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M20.782 3.923l.525 1.078-5.005 9.796c-.409.712-1.749.234-1.336-.682l4.552-8.909L6.321 2.651 2.855 13.135l5.942 6.612c.442.666-.453 1.659-1.161.946l-6.188-6.879-.154-.737 3.81-11.523.855-.501 14.823 2.87z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "secondary",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.929 17.652H10v4.071H5.929zM.25 11.372h4.071v4.071H.25zM4.483.25h4.071v4.071H4.483zM18.214 2.832h4.071v4.071h-4.071zM13.28 11.961h4.071v4.071H13.28z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "primary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.527 20.085l2.359 2.359a.632.632 0 01-.893.893l-2.359-2.359-.358 1.434a.63.63 0 01-1.195.07l-1.887-5.032a.632.632 0 01.805-.811l5.031 1.887a.63.63 0 01-.063 1.201l-1.446.358h.006z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 17.652v4.071l-.25.25H5.929l-.25-.25v-4.071l.25-.25H10l.25.25zm-4.071.25v3.571H9.75v-3.571H6.179zM4.571 11.372v4.071l-.25.25H.25l-.25-.25v-4.071l.25-.25h4.071l.25.25zm-4.071.25v3.571h3.571v-3.571H.5zM8.804.25v4.071l-.25.25H4.483l-.25-.25V.25l.25-.25h4.071l.25.25zM4.733 4.071h3.571V.5H4.733v3.571zM22.535 2.832v4.071l-.25.25h-4.071l-.25-.25V2.832l.25-.25h4.071l.25.25zm-4.071.25v3.571h3.571V3.082h-3.571zM17.601 11.961v4.071l-.25.25H13.28l-.25-.25v-4.071l.25-.25h4.071l.25.25zm-4.071.25v3.571h3.571v-3.571H13.53z"
  }))));
}
export default SvgIconSelectShape;